var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-right"},[_c('v-btn',{attrs:{"id":"botaoSalvarAvancar","color":"primary","depressed":""},on:{"click":function($event){return _vm.$emit('salvarEAvancar')}}},[_vm._v(" Continuar "),_c('v-icon',{staticClass:"ml-1",attrs:{"size":"15"}},[_vm._v("keyboard_arrow_right")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }